type DateLike = Date | string;

type PeriodRangeLike = {
  from: DateLike;
  to: DateLike;
};

type PeriodLike = {
  current: PeriodRangeLike;
  previous?: PeriodRangeLike;
};

type PeriodContainer = {
  period?: PeriodLike;
};

export function formatPeriodDate(value: DateLike): string {
  const date = value instanceof Date ? value : new Date(value);
  return date.toISOString().split('T')[0];
}

export function formatPeriodRange<T extends PeriodRangeLike>(range: T): T {
  return {
    ...range,
    from: formatPeriodDate(range.from),
    to: formatPeriodDate(range.to)
  } as T;
}

export function withFormattedPeriodRanges<T extends PeriodContainer>(payload: T): T {
  if (!payload.period) {
    return payload;
  }

  return {
    ...payload,
    period: {
      ...payload.period,
      current: formatPeriodRange(payload.period.current),
      previous: payload.period.previous ? formatPeriodRange(payload.period.previous) : payload.period.previous
    }
  } as T;
}

